// extracted by mini-css-extract-plugin
export var btn = "customlink-module--btn--b1578";
export var btn__black = "customlink-module--btn__black--a5899";
export var btn__icon = "customlink-module--btn__icon--5cf18";
export var btn__wrapper = "customlink-module--btn__wrapper--fbe25";